export default __webpack_public_path__ + "static/media/trustAc-2.7213d383.svg";